export default async function processImageFile(file: File): Promise<File | null> {
  return new Promise((resolve) => {
    const reader = new FileReader()

    reader.onload = (e) => {
      const img = new Image()

      img.onload = () => {
        const A4_WIDTH = 794
        const A4_HEIGHT = 1123

        const canvas = document.createElement('canvas')
        const ctx = canvas.getContext('2d')
        canvas.width = A4_WIDTH
        canvas.height = A4_HEIGHT

        // Fundo branco
        // @ts-ignore
        ctx.fillStyle = '#ffffff'
        // @ts-ignore
        ctx.fillRect(0, 0, A4_WIDTH, A4_HEIGHT)

        // Redimensiona proporcionalmente para "contain"
        const scale = Math.min(A4_WIDTH / img.width, A4_HEIGHT / img.height)
        const newWidth = img.width * scale
        const newHeight = img.height * scale

        const x = (A4_WIDTH - newWidth) / 2
        const y = (A4_HEIGHT - newHeight) / 2

        if (ctx) {
          ctx.drawImage(img, x, y, newWidth, newHeight)
        }

        canvas.toBlob((blob) => {
          if (!blob) return resolve(null)

          const a4File = new File([blob], file.name, { type: 'image/jpeg' })
          resolve(a4File)
        }, 'image/jpeg', 0.8)
      }

      img.src = (e && e.target) ? e.target.result as string : ''
    }

    reader.readAsDataURL(file)
  })
}
